var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.doc)?_c('v-row',_vm._l((_vm.doc.selectedTiles),function(card){return _c('div',{key:card.id,style:({ width: _vm.computedWidh }),attrs:{"data-id":card.id}},[_c('show-card',{attrs:{"card":card}})],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }